// 2020-06-27export { PesoHaciendaComponent } from './peso-hacienda.component';